import { Api } from '@recargas-dominicanas/core/api';

import type { 
  IBusiness, 
  BusinessProduct, 
  IPage, 
  ISalesReport, 
  ITransaction, 
  IBusinessUser, 
  IBalance, 
  BusinessSales
} from '@recargas-dominicanas/core/types';

export class BusinessApi extends Api {

  public static async getAll(page: number, size: number, query: string) {
    return this.get<IPage<IBusiness>>('/dist/business', {
      params: {
        page,
        size,
        q: query
      }
    });
  }

  public static async getById(businessId: number) {
    return this.get<IBusiness>(`/dist/business/${businessId}`);
  }

  public static async getProducts(businessId: number) {
    return this.get<BusinessProduct[]>(`/dist/business/${businessId}/products`);
  }

  public static async getBalances(businessId: number, page: number, size: number) {
    return this.get<IPage<IBalance>>(`/dist/business/${businessId}/balances?page=${page}&size=${size}`);
  }

  public static async getSalesReports(businessId: number, page: number, size: number) {
    return this.get<IPage<ISalesReport>>(`/dist/business/${businessId}/sales-reports?page=${page}&size=${size}`);
  }

  public static async getTransactions(businessId: number, page: number, size: number) {
    return this.get<IPage<ITransaction>>(`/dist/business/${businessId}/transactions?page=${page}&size=${size}`);
  }

  public static async getUsers(businessId: number) {
    return this.get<IBusinessUser[]>(`/dist/business/${businessId}/users`);
  }

  public static async getSales(businessId: number, params: { startDate: string; endDate: string; period: 'day' | 'month' }) {
    return this.get<BusinessSales>(`/dist/business/${businessId}/sales`, { params });
  }

  public static async add(business: {
    name: string;
    rnc?: string;
    phone?: string;
    email?: string;
    city: string;
    address: string;
  }) {
    return this.post<IBusiness>('/dist/business', business);
  }

  public static async update(
    businessId: number, 
    business: {
      name?: string;
      rnc?: string;
      phone?: string;
      email?: string;
      city?: string;
      address?: string;
    }
  ) {
    return this.patch<IBusiness>(`/dist/business/${businessId}`, business);
  }

  public static async addBalance(businessId: number, balance: number) {
    return this.post(`/dist/business/${businessId}/balance`, { balance });
  }

  public static async updateUserPassword(businessId: number, userId: number, password: string) {
    return this.patch(`/dist/business/${businessId}/users/${userId}/password`, { password });
  }

  public static async updateProduct(businessId: number, productId: number, data: { profit: number }) {
    return this.patch<BusinessProduct>(`/dist/business/${businessId}/products/${productId}`, data);
  }
}
